// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--ag-nw"};